import React from 'react';
import { LogoMark } from '../components/deck/LogoMark';
import { Slide } from '../components/deck/Slide';
import { Eyebrow, Reveal, Title } from '../components/deck/Type';
import { logoWall } from '../data/logos';
export function ValidationSlide() {
  return <Slide index={10} data-id="element-574" data-mp="1esivnk3h4fze">
      <Eyebrow data-id="element-575" data-mp="1ap2zspz8ajnr">Customers &amp; partners</Eyebrow>
      <Title className="mt-[2.2cqh] max-w-[70%]" data-id="element-576" data-mp="1apco894mkirc">
        Trusted by leading organisations across the venture ecosystem.
      </Title>

      <div className="mt-auto grid grid-cols-6 gap-[1cqw]" data-id="element-577" data-mp="i05gcjja6gtf">
        {logoWall.map((logo, i) => <Reveal key={logo.id} delay={0.03 * i} className="flex h-[22cqh] items-center justify-center bg-white" data-id="element-578" data-mp="vzx0l20e4tfv" data-mpi={i}>
            <LogoMark logo={logo} maxW={24} maxH={13} area={95} data-id="element-579" data-mp="qzafns2o2e6n" />
          </Reveal>)}
      </div>

      <Reveal delay={0.4} className="mt-[3cqh] flex items-center justify-between border-t border-white/12 pt-[2cqh]" data-id="element-580" data-mp="27d8xsu1nadt2">
        <p className="text-[clamp(10.5px,1.14cqw,24px)] text-[#C3CBD9]" data-id="element-581" data-mp="2wg213hekbxji">
          Enterprise customers, venture funds, corporates, programs and
          ecosystem partners.
        </p>
        <span className="text-[clamp(8px,0.82cqw,17px)] uppercase tracking-[0.22em] text-[#8B95A8]" data-id="element-582" data-mp="35ggpwqqqjurr">
          Not every organisation is a paying customer
        </span>
      </Reveal>
    </Slide>;
}